import {Component, OnInit} from '@angular/core';
import {LoginInfoComponent} from "@app/shared/user/login-info/login-info.component";
import { AuthService } from '@app/core/services';


@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  constructor(public auth: AuthService) {
  }

  ngOnInit() {
  }

  isAuthorized(page: string, rol: string){
    if(rol=='superadmin')
      return true;
    if(rol=='admin'){
      if(page=='users' || page=='monitoring' || page=='shops' || page=='config'
          || page=='orders/actives' || page=='orders/history' || page=='reports' 
          || page=='promotions/actives' || page=='promotions/history' || page=='promotions/pending')
        return true;
      return false;
    }
    if(rol=='supervisor'){
      if(page=='monitoring' 
          || page=='orders/actives' || page=='orders/history' )
        return true;
      return false;
    }

    if(rol=='comercio'){
      if(page=='menu')
        return true;
    }

    if(rol=='comercio' || rol=='caja'){
      if(page=='orders/my-actives'
          || page=='orders/my-history')
        return true;
      return false;
    }

  }

  openMonitoring(){
    window.location.href = "/#/monitoring";
    window.location.reload();
  }
}
